export default __webpack_public_path__ + "static/media/errorTask.b2d6fbc1.png";